import actions from './index';
import { BASE_URL } from '../constants/api';

export const ACTIONS = {
  GET: 'CHAPTER_ANALYTICS_GET',
  GET_SUCCESS: 'CHAPTER_ANALYTICS_GET_SUCCESS',
  GET_FAILURE: 'CHAPTER_ANALYTICS_GET_FAILURE',
  INVALIDATE_ITEM: 'CHAPTER_ANALYTICS_INVALIDATE_ITEM',
  GET_ALL: 'CHAPTER_ANALYTICS_GET_ALL',
  GET_ALL_SUCCESS: 'CHAPTER_ANALYTICS_GET_ALL_SUCCESS',
  GET_ALL_FAILURE: 'CHAPTER_ANALYTICS_GET_ALL_FAILURE',
};

export const invalidateItem = id => dispatch => {
  dispatch({
    type: ACTIONS.INVALIDATE_ITEM,
    payload: {
      id,
    },
  });
};

export const getAll = actions.getAll(
  ({ chapterCode, chapterVersion }) =>
    `${BASE_URL}/intelanalytics/node-aggregate/${chapterCode}/${chapterVersion}`,
  {
    PENDING: ACTIONS.GET_ALL,
    SUCCESS: ACTIONS.GET_ALL_SUCCESS,
    FAILURE: ACTIONS.GET_ALL_FAILURE,
  },
);
